"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = computeProgress;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _computePoint = _interopRequireDefault(require("./computePoint"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

function computeProgress(_ref) {
  var event = _ref.event,
      roundingAccuracy = _ref.roundingAccuracy,
      end = _ref.end,
      start = _ref.start,
      step = _ref.step,
      progressBar = _ref.progressBar,
      fromPointer = _ref.fromPointer,
      toPointer = _ref.toPointer,
      value = _ref.value;

  var _ref2 = value || [],
      _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
      from = _ref3[0],
      to = _ref3[1],
      point = (0, _computePoint["default"])({
    x: event.pageX,
    roundingAccuracy: roundingAccuracy,
    end: end,
    start: start,
    step: step,
    offset: (0, _documentOffset["default"])(progressBar),
    offsetWidth: progressBar.offsetWidth
  });

  var nextFrom = from,
      nextTo = to;

  if (fromPointer) {
    nextFrom = point >= end ? point - step : point;
    nextTo = !isNaN(to) && nextFrom >= to ? to + step : to;
  } else if (toPointer) {
    nextTo = point <= start ? point + step : point;
    nextFrom = !isNaN(from) && from >= nextTo ? from - step : from;
  }

  return [nextFrom, nextTo];
}